module.exports = __webpack_public_path__ + "img/Bosna in Hercegovina.2b5c04ca.png";